// 存放业务统一限制展示样式的配置，方便如果之后还有特殊的样式类型的也放在里面

// 字体颜色映射
export const FontColorMap: Record<string, string> = {
  success: '#00a63e', // 例如：首期租金已支付的"是"
  danger: '#ff4d4f',  // 例如：决策截止时间临期的红色
  textSecondary: '#8e8e93', // 次要文案颜色
};

// 风控类型标签颜色映射 (Custom Tailwind Colors)
export const RiskTagColorMap: Record<string, string> = {
  '通过': '#1890ff',
  '预收': '#f39c12',
  '高风险': '#ff4757',
  '盲发': '#00d68f',
  '盲发必发': '#00d68f',
};

// 设备机型/成色标签颜色映射
export const DeviceTagColorMap: Record<string, { color: string; background: string }> = {
  '全新苹果': { color: '#e11d48', background: '#ffe4e6' },
  '二手苹果': { color: '#2563eb', background: '#dbeafe' },
  '全新安卓': { color: '#d97706', background: '#fef3c7' },
  '二手安卓': { color: '#059669', background: '#d1fae5' },
};

// 解析 skuName 并拆分为套餐/颜色/内存 (移植自后端 Go 代码)
export const parseSkuNameParts = (skuName?: string): { packageName: string; color: string; memory: string } => {
  const trimmed = (skuName || '').trim();
  if (!trimmed) return { packageName: '', color: '', memory: '' };

  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { packageName: '', color: '', memory: '' };

  if (parts.length === 1) return { packageName: parts[0], color: '', memory: '' };

  let packageName = '';
  let color = '';
  let memory = '';

  const appendField = (targetName: 'packageName' | 'color' | 'memory', value: string) => {
    if (!value) return;
    if (targetName === 'packageName') {
      packageName = packageName ? `${packageName} ${value}` : value;
    } else if (targetName === 'color') {
      color = color ? `${color} ${value}` : value;
    } else if (targetName === 'memory') {
      memory = memory ? `${memory} ${value}` : value;
    }
  };

  const unknowns: string[] = [];

  for (const item of parts) {
    const candidate = item.split('-')[0].trim();
    const upper = candidate.toUpperCase();

    const hasDigit = /\d/.test(upper);
    const isMemory = hasDigit && upper.includes('B');

    if (isMemory) {
      appendField('memory', candidate);
      continue;
    }

    let isColor = item.includes('色');
    if (!isColor) {
      const colorKws = ['红', '橙', '黄', '青', '绿', '蓝', '黑', '白', '灰', '暗', '苍', '柔', '银'];
      if (colorKws.some(kw => item.includes(kw))) {
        isColor = true;
      }
    }
    if (isColor) {
      appendField('color', item);
      continue;
    }

    let isPackage = false;
    const packageKws = ['到期', '租', '还', '买'];
    if (packageKws.some(kw => item.includes(kw))) {
      isPackage = true;
    }
    if (isPackage) {
      appendField('packageName', item);
      continue;
    }

    unknowns.push(item);
  }

  if (parts.length === 3 && unknowns.length > 0) {
    let index = 0;
    if (!packageName && index < unknowns.length) {
      packageName = unknowns[index];
      index++;
    }
    if (!color && index < unknowns.length) {
      color = unknowns[index];
      index++;
    }
    if (!memory && index < unknowns.length) {
      memory = unknowns[index].split('-')[0].trim();
    }
  }

  return { packageName, color, memory };
};
